export default __webpack_public_path__ + "static/media/Cat's Eye Ring.a44f1117.jpg";